export enum EProductTotalsItems {
  TIP = 'Tip',
  OTHER_PAYMENTS = 'Other payments',
  GIFTCARD = 'GiftCard',
  GRATUITY = 'Gratuity',
  ITEM_TOTAL = 'Item total',
}
